import React, { useEffect, useState } from 'react'
import { Table, Flex, } from 'antd'; 
import Main from '../../cpn/Main';
import ClientTypeEdit from './ClientTypeEdit';
import ClientAdd from './ClientTypeAdd';
import {  useKehulxListQuery } from '../../store/DianShangYeWuApi';
import classes from '../system.module.css';
function ClientTypeList() {
    const [list, setList] = useState();    
    const qy_id = JSON.parse(localStorage.getItem('jtg-caiwu_qy_id'))
    const qy_name = JSON.parse(localStorage.getItem('jtg-caiwu_qy_name'))   
    const yh_id = JSON.parse(localStorage.getItem('jtg-caiwu_yh_id'))
    const yh_name = JSON.parse(localStorage.getItem('jtg-caiwu_yh_name'))
  
    const {data, isSuccess} = useKehulxListQuery({khlx_qy_id:qy_id});
    useEffect(() => {
        if (isSuccess) {
            // console.log(data);
            if(data.Status==='success'){                
                const newArr = data.Result.map(item => {
                    const {khlx_id:key,khlx_name,khlx_cname,khlx_ctime,khlx_update_time,khlx_update_uname} = item;                 
                    return item = {key,khlx_name,khlx_cname,khlx_ctime,khlx_update_time,khlx_update_uname}
                }) 
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.khlx_ctime;
                    let bTimeString = b.khlx_ctime;
                    let aTime = new Date(aTimeString).getTime();
                    let bTime = new Date(bTimeString).getTime();
                    return bTime - aTime;     
                    },)
                setList(sortArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])
    const columns = [
        {
            key: 'khlx_name',
            title: '名称',            
            dataIndex: 'khlx_name',
            render: (_, record) =>  <ClientTypeEdit
                                        khlx_id={record.key} 
                                        khlx_name={record.khlx_name} 
                                        qy_id={qy_id}
                                        qy_name={qy_name}
                                        yh_id={yh_id}
                                        yh_name={yh_name} 
                                        khlx_ctime={record.khlx_ctime}
                                        khlx_update_time={record.khlx_update_time}
                                        khlx_cname={record.khlx_cname}
                                        khlx_update_uname={record.khlx_update_uname}
                                    />
        },              
        {
            key: 'key',
            title: '编号',
            dataIndex: 'key',
        },                 
    ]   
    return (
        <Main selectedKeys={['/ClientTypeList']}>            
            <Flex align='center' justify='flex-end'>                
                <ClientAdd 
                    qy_id={qy_id}
                    qy_name={qy_name}
                    yh_id={yh_id}
                    yh_name={yh_name}
                />
            </Flex>        
            <Table 
                columns={columns} 
                dataSource={list} 
                pagination={{
                    showSizeChanger:true,
                    defaultPageSize:'50',
                    showTotal:(total) => `共${total}条`,
                }} 
                className={classes.customTable}
                style={{marginTop:"10px"}}
                bordered
                size='small'
                rowKey="key"
            />
        </Main>
    )
}

export default ClientTypeList
